/**
 *  input의 상태 업데이트 공통 로직 리듀서.
 * @param {any} state 상태
 * @param {any} action action은 객체로써 type, target 스키마를 갖고 있다. type 은 INIT, SINGLE 또는 OBJECT가 있으며
 * type이 INIT이면 target에는 value에 꼭 초기값이 들어가 있어야 하며, 나머지 type의 target은 name, checked, value의 값을 가지고 있어야한다.
 * 그리고 target의 type 이 self인 경우는 직접 넣을 값의 타입을 알고 있고 그 값을 바로 넣을 때 사용되는 로직이다. 그래서 target의 type과 value가 꼭 있어야 한다.
 *  */
export default function inputReducer<T>(state: T, action: any): T {
  const TYPE: string = action.type;
  if (TYPE === 'INIT') {
    return action.target.value;
  }

  const { name, checked, value, type }: any = action.target;
  const data: string | number | boolean = type === 'self' ? value : dataType(type, checked, value);

  switch (TYPE) {
    case 'SINGLE':
      return data as T;

    case 'OBJECT':
      return {
        ...state,
        [name]: data,
      };

    default:
      console.error(`알 수 없는 타입 ${type}. inputReducer`);
      return state;
  }
}

/**
 *  dataType에 따라 자료형을 변경해주어 리턴해준다.
 * @param {string} type element의 type
 * @param {boolean} checked element의 checked
 * @param {string} value element의 value
 * @returns 업데이트 될 데이터를 리턴해준다. true or false and any value(string or number)
 *  */
const dataType = (type: string, checked: boolean, value: string): string | number | boolean => {
  let data: string | number | boolean = '';

  if (type === 'text' || type === 'radio') {
    data = Number(value) ? Number(value) : value;
  } else if (type === 'number') {
    data = Number(value);
  } else if (type === 'checkbox') {
    data = checked;
  }

  return data;
};
